import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from '../../actions/ModalActions';
import Modal from '../Modal';

/**
 * Yes/no confirmation on the redux Modal (the existing ConfirmationModal is
 * a C3 modal with its own URL-driven API, which does not fit service calls).
 * Props: title, message, confirmText, onConfirm(); closes itself.
 */
@connect(
    () => ({}),
    dispatch => bindActionCreators({ closeModal }, dispatch)
)
export default class ConfirmModal extends Component {
    handleConfirm() {
        this.props.closeModal();
        this.props.onConfirm();
    }

    render() {
        var actionButton = (
            <button className={`btn ${this.props.danger === false ? 'btn-primary' : 'btn-danger'}`} onClick={this.handleConfirm.bind(this)}>
                {this.props.confirmText || 'Confirm'}
            </button>
        );
        return (
            <Modal actionButton={actionButton} className={this.props.danger === false ? 'modal-primary' : 'modal-danger'} title={this.props.title || 'Are you sure?'}>
                <p>{this.props.message}</p>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/discounts/ConfirmModal.js